import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "../styles/TeacherResources.module.scss";
import Loader from "../../../../utils/loader/loader";
import ToastMessage from "../../../../utils/toasts/toastMessage";
import { createResource } from "../../../../Redux/Teacher_Panel/Teacher_Resource/resource.action";
import {
  getPdfData,
  getPdfList,
} from "../../../../Redux/resource/resource.action";
import { GET_PROFILE_DETAILS } from "../../../../utils/api";
import { useClassDivision } from "../../../../Reusable_Components/multiClassDivisionSelector";
import { profileDetails } from "../../../../Redux/profile/profile.action";

/* helper: small PDF SVG thumbnail (fallback) */
function pdfSvgDataUrl(label = "PDF") {
  const svg = encodeURIComponent(`
    <svg xmlns='http://www.w3.org/2000/svg' width='240' height='300' viewBox='0 0 240 300'>
      <rect width='100%' height='100%' fill='#f8fafc' rx='12' />
      <rect x='12' y='12' width='216' height='276' fill='#fff' stroke='#e6e9ee' rx='8' />
      <text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' font-family='Arial, Helvetica, sans-serif' font-size='28' fill='#ef4444' font-weight='700'>${label}</text>
    </svg>
  `);
  return `data:image/svg+xml;utf8,${svg}`;
}
// const BOARD_OPTIONS = ["CBSE", "ICSE", "NIOS", "CISCE", "IB"];
// const MEDIUM_OPTIONS = ["English", "Hindi"];
const DIVISION_OPTIONS = ["A", "B", "C"];

export default function AddNewModal({
  open,
  onClose,
  selectedType,
  onAddResource,
}) {
  const dispatch = useDispatch();
  const [form, setForm] = useState({
    subject: "",
    subjectType: "",
    chapter: "",
    // className: "",
    // board: "",
    // medium: "",
    // division:"",
  });
  const [preview, setPreview] = useState(null); // dataURL or svg
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadedDataUrl, setUploadedDataUrl] = useState(null); // dataURL for images, blobUrl for PDFs
  const [loading, setLoading] = useState(false);
  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "",
  });

  const [resourceList, setResourceList] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState("");

  const [coverFile, setCoverFile] = useState(null);

  const [coverDataUrl, setCoverDataUrl] = useState(null);

  const [coverPreview, setCoverPreview] = useState(null);

  const [selectedClasses, setSelectedClasses] = useState({});

  // const store = useSelector((state) => state);

  const teacherDetails = useSelector(
    (state) => state?.ProfileManager?.user_details,
  );
  const { uniqueGrades, getDivisionsByGrade } = useClassDivision(
    teacherDetails?.classes,
  );

  const resourceStore = useSelector(
    (store) => store?.ResourceManager?.pdfMetaData,
  );

  useEffect(() => {
    dispatch(profileDetails());
    dispatch(getPdfData());
  }, [dispatch]);

  useEffect(() => {
    if (resourceStore) {
      setResourceList(resourceStore);
      //  setSelectedClasses(buildInitialState());
    }
  }, [resourceStore]);

  // ----------------------------------------subject and chapter options -------------------------------

//   const subjectChapterMap = useMemo(() => {
//   const map = {};

//   const classes = teacherDetails?.classes || [];

//   classes.forEach((cls) => {
//     const subjects = cls?.subject || [];

//     subjects.forEach((sub) => {
//       const subject = sub?.trim();

//       if (subject && !map[subject]) {
//         map[subject] = [];
//       }
//     });
//   });

//   return map;
// }, [teacherDetails]);

const subjectChapterMap = useMemo(() => {
    const map = {};
    const classes = teacherDetails?.classes || [];

    classes.forEach((cls) => {
      const subjects = cls?.subject || [];
      subjects.forEach((sub) => {
        const subject = sub?.trim();
        if (subject && !map[subject]) {
          map[subject] = [];
        }
      });
    });

    return map;
  }, [teacherDetails]);

  // NEW: classes filtered to only those that teach the selected subject
  const classesForSubject = useMemo(() => {
    if (!selectedSubject) return [];
    const classes = teacherDetails?.classes || [];
    return classes.filter((cls) =>
      (cls?.subject || []).some((s) => s?.trim() === selectedSubject)
    );
  }, [teacherDetails, selectedSubject]);

  // NEW: reset the class selection whenever subject changes, since the
  // previously picked grade/division may not teach the new subject
  useEffect(() => {
    setSelectedClasses("");
  }, [selectedSubject]);

  const handleMultiSelectChange = (e) => {
    const selected = Array.from(e.target.selectedOptions).map(
      (option) => option.value,
    );
    setSelectedClasses(selected[0]);
  };

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
      setForm({
        subjectType: "",
        chapter: "",
      });
      setPreview(null);
      setUploadedFile(null);
      setUploadedDataUrl(null);
      const f = document.getElementById("fileInput");
      if (f) f.value = "";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  const handleChange = (key, value) =>
    setForm((prev) => ({ ...prev, [key]: value }));

  // UPDATED: Use Blob URL for PDFs to avoid about:blank#blocked; keep FileReader for images
  const handleFileChange = (e) => {
    const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB
    const file = e.target.files?.[0];
    if (!file) return;

      if (file.size > MAX_FILE_SIZE) {
    setToastState({
      show: true,
      message: "File size must be 10MB or less.",
      type: "error",
    });
    e.target.value = "";
    return;
  }

    setUploadedFile(file);

    if (file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (ev) => {
        const dataUrl = ev.target.result;
        setUploadedDataUrl(dataUrl);
        setPreview(dataUrl);
      };
      reader.readAsDataURL(file);
    } else if (file.type === "application/pdf") {
      // Blob URL for PDF — browsers accept this in iframe/object
      const blobUrl = URL.createObjectURL(file);
      setUploadedDataUrl(blobUrl);
      setPreview(pdfSvgDataUrl("PDF"));
    } else {
      // other files: use blob URL as fallback
      const blobUrl = URL.createObjectURL(file);
      setUploadedDataUrl(blobUrl);
      setPreview(pdfSvgDataUrl("FILE"));
    }
  };

  const handleRemovePreview = () => {
    // revoke blob URL if any (clean up)
    if (
      uploadedDataUrl &&
      uploadedFile &&
      uploadedFile.type === "application/pdf"
    ) {
      try {
        URL.revokeObjectURL(uploadedDataUrl);
      } catch (e) {
        /* ignore */
      }
    }
    setPreview(null);
    setUploadedFile(null);
    setUploadedDataUrl(null);
    const f = document.getElementById("fileInput");
    if (f) f.value = "";
  };

  const handleCoverChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setCoverFile(file);
    if (file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (ev) => {
        setCoverDataUrl(ev.target.result);
        setCoverPreview(ev.target.result);
      };

      reader.readAsDataURL(file);
    }
  };

  const removeCover = () => {
    setCoverFile(null);
    setCoverDataUrl(null);
    setCoverPreview(null);
    const c = document.getElementById("coverInput");
    if (c) c.value = "";
  };

  const handleRemoveCoverPreview = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    removeCover();
  };

  const parseClassDivision = (value) => {
    if (!value) return { grade: "", division: "" };

    // ensure string
    value = String(value);

    const gradeMatch = value.match(/\d+/);
    const grade = gradeMatch ? gradeMatch[0] : "";

    let division = "";

    if (value.includes("-")) {
      division = value.split("-").pop().trim();
    } else {
      const divMatch = value.match(/[A-Za-z]+$/);
      division = divMatch ? divMatch[0] : "";
    }

    return { grade, division };
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    const { grade, division } = parseClassDivision(selectedClasses);
    if (
      !selectedSubject ||
      !form.subjectType ||
      !form.chapter ||
      !selectedClasses ||
      !uploadedFile
    ) {
      setToastState({
        show: true,
        message: "Please fill all the fields before proceeding!",
        type: "error",
      });
      setLoading(false);
      return;
    }

    const payload = {
      file: uploadedFile,
      subject: selectedSubject,
      chapter: form.chapter,
      division: division,
      subject_type: form.subjectType,
      grades: grade,
      cover_image: coverFile || null,
    };

    const result = await dispatch(createResource(payload));

    if (result) {
      dispatch(getPdfData());
      dispatch(getPdfList());
      setToastState({
        show: true,
        message: "Study material uploaded successfully.",
        type: "success",
      });

      setTimeout(() => {
        onClose();
      }, 500);
    } else {
      setToastState({
        show: true,
        message: "Something went wrong! Try again.",
        type: "error",
      });
    }
    setLoading(false);
  };

  const coverEnabled = !!uploadedFile;

  return (
    <>
      <div className={styles.addModalOverlay} role="dialog" aria-modal="true">
        <div className={styles.addModal} onClick={(e) => e.stopPropagation()}>
          <button className={styles.addModalClose} onClick={onClose}>
            ×
          </button>

          {/* hidden file inputs */}
          <input
            id="fileInput"
            type="file"
            accept="image/*,application/pdf"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          <input
            id="coverInput"
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={handleCoverChange}
            disabled={!coverEnabled}
          />

          <div className={styles.addModalHeader}>
            {/* PDF upload block */}
            <div className={styles.uploadBlock}>
              <div className={styles.uploadBadgeRow}>
                <div className={styles.badgeWrapper}>
                  <label
                    htmlFor="fileInput"
                    className={styles.addModalIcon}
                    title="Upload PDF / image"
                  >
                    {preview ? (
                      <img
                        src={preview}
                        alt="Uploaded"
                        style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }}
                      />
                    ) : (
                      "+"
                    )}
                  </label>
                  {uploadedFile && (
                    <button
                      type="button"
                      className={styles.removeBadgeBtn}
                      onClick={handleRemovePreview}
                      title="Remove file"
                    >
                      ×
                    </button>
                  )}
                </div>
              </div>
              <div className={styles.uploadInfo}>
                {uploadedFile ? (
                  <span className={styles.uploadFileName}>{uploadedFile.name}</span>
                ) : (
                  <div className={styles.addModalTitle}>Add Resource</div>
                )}
                <div className={styles.addModalSub}>Click + to upload file (image / PDF)</div>
              </div>
            </div>

            {/* Cover image block */}
            <div
              className={`${styles.uploadBlock} ${!coverEnabled ? styles.disabledPlaceholder : ""}`}
              onClick={!coverEnabled ? () =>
                setToastState({ show: true, message: "Please upload the PDF first.", type: "error" })
                : undefined
              }
            >
              <div className={styles.uploadBadgeRow}>
                <div className={styles.badgeWrapper}>
                  <label
                    htmlFor="coverInput"
                    className={styles.addModalIcon}
                    style={{ cursor: coverEnabled ? "pointer" : "not-allowed" }}
                    title={coverEnabled ? "Upload cover image" : "Upload PDF first"}
                  >
                    {coverPreview ? (
                      <img
                        src={coverPreview}
                        alt="Cover"
                        style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }}
                      />
                    ) : (
                      "+"
                    )}
                  </label>
                  {coverPreview && (
                    <button
                      type="button"
                      className={styles.removeBadgeBtn}
                      onClick={handleRemoveCoverPreview}
                      title="Remove cover"
                    >
                      ×
                    </button>
                  )}
                </div>
              </div>
              <div className={styles.uploadInfo}>
                <div className={styles.addModalTitle}>{selectedType || "Digital Books"}</div>
                <div className={styles.addModalSub}>
                  {coverEnabled ? "Upload cover image" : "Upload cover after adding resource"}
                </div>
              </div>
            </div>
          </div>
          <form className={styles.addForm} onSubmit={handleSubmit}>
            <div className={styles.formRow}>
              <div className={styles.formHalf}>
                <label>Subject</label>
                {/* <input
                  className={styles.addInput}
                  placeholder="Subject"
                  value={form.subject}
                  onChange={(e) => handleChange("subject", e.target.value)}
                /> */}
                <select
                  className="form-select custom-input"
                  value={selectedSubject}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSelectedSubject(value);
                  }}
                  // disabled={editing && quizData?.subject}
                >
                  <option value="">Choose Subject...</option>
                  {Object.keys(subjectChapterMap).map((subject) => (
                    <option key={subject} value={subject}>
                      {subject}
                    </option>
                  ))}
                </select>
              </div>
              <div className={styles.formHalf}>
                <label>Subject Type</label>
                <input
                  className={styles.addInput}
                  placeholder="Subject Type"
                  value={form.subjectType}
                  onChange={(e) => handleChange("subjectType", e.target.value)}
                />
              </div>
            </div>

            <div className={styles.formRow}>
              <div className={styles.formHalf}>
                <label>Chapter</label>
                <input
                  className={styles.addInput}
                  placeholder="Chapter"
                  value={form.chapter}
                  onChange={(e) => handleChange("chapter", e.target.value)}
                />
              </div>
          
              {/* <div className={styles.formHalf}>
                <label>Class</label>
                <select
                  className={styles.addInput}
                  // className="form-select custom-input"
                  value={selectedClasses}
                  onChange={handleMultiSelectChange}
                >
                  <option value="">Choose Class...</option>
                  {uniqueGrades.map((grade) =>
                    getDivisionsByGrade(grade).map((division) => {
                      const value = `${grade}${division}`;
                      return (
                        <option key={value} value={value}>
                          {grade}
                          {division}
                        </option>
                      );
                    }),
                  )}
                </select>
              </div> */}
              <div className={styles.formHalf}>
  <label>Class</label>
  <select
    className={styles.addInput}
    value={selectedClasses}
    onChange={handleMultiSelectChange}
    disabled={!selectedSubject}
  >
    <option value="">
      {selectedSubject ? "Choose Class..." : "Select subject first"}
    </option>
    {classesForSubject.map((cls) => {
      const value = `${cls.grade}${cls.division}`;
      return (
        <option key={value} value={value}>
          {cls.grade}
          {cls.division}
        </option>
      );
    })}
  </select>
</div>
            
            </div>

            {/* <div className={styles.formRow}>
              <div className={styles.formHalf}>
                <label>Board</label>
                <select
                  className={styles.addInput}
                  value={form.board}
                  onChange={(e) => handleChange("board", e.target.value)}
                >
                  <option value="">Select board</option>
                  {BOARD_OPTIONS.map((b) => (
                    <option key={b} value={b}>
                      {b}
                    </option>
                  ))}
                </select>
              </div>
              <div className={styles.formHalf}>
                <label>Medium</label>
                <select
                  className={styles.addInput}
                  value={form.medium}
                  onChange={(e) => handleChange("medium", e.target.value)}
                >
                  <option value="">Select medium</option>
                  {MEDIUM_OPTIONS.map((m) => (
                    <option key={m} value={m}>
                      {m}
                    </option>
                  ))}
                </select>
              </div>
            </div> */}

            {/* <div className={styles.formRow}>
              <div className={styles.formHalf}>
                <label>Division</label>
                <select
                  className={styles.addInput}
                  value={form.division}
                  onChange={(e) => handleChange("division", e.target.value)}
                >
                  <option value="">Select division</option>
                  {DIVISION_OPTIONS.map((m) => (
                    <option key={m} value={m}>
                      {m}
                    </option>
                  ))}
                </select>
              </div>
                   <div className={styles.formHalf}>
             
              </div>
         
            </div> */}

            <div className={styles.addActions}>
              <button
                type="submit"
                className={styles.addSubmit}
                disabled={!form.subject && !uploadedFile}
              >
                Submit
              </button>
            </div>
          </form>
          <ToastMessage
            show={toastState.show}
            onClose={() =>
              setToastState({ show: false, message: "", type: "" })
            }
            message={toastState.message}
            type={toastState.type}
          />
        </div>
        <Loader show={loading} />
      </div>
    </>
  );
}
